import * as React from 'react';
import { Table, SortableTableHeader } from "soprasteria-ui-library";
import { IOrthodonticReferral } from '../../../models/IOrthodonticReferral';
import { Link } from 'react-router-dom';
import { PATIENT, ORTHODONTIC_REFERRAL } from '../../../utils/RouteConstants';
import { dateTimeToDateString } from '../../../helpers/DateHelper';
import { formatPersonalSecurityNumberAndOrganisationNumber } from '../../../helpers/PersonalSecurityNumberAndOrganisationNumberHelper';

interface IOrthodonticReferralSearchTable {
    orthodonticReferrals: IOrthodonticReferral[];
}

export const OrthodonticReferralSearchTable: React.FunctionComponent<IOrthodonticReferralSearchTable> = ({ orthodonticReferrals }) => {

    const renderTableLink = (orthodonticReferral: IOrthodonticReferral, linkText?: string) => {
        return <Link to={`${PATIENT}/${orthodonticReferral.patientGuidId}/${ORTHODONTIC_REFERRAL}/${orthodonticReferral.orthodonticReferralId}`}>{linkText}</Link>
    }

    return (
        <Table hoverableRows>
            <thead>
                <tr>
                    <SortableTableHeader propertyToSortBy="SentDate" headerText="Datum skickad" />
                    <SortableTableHeader propertyToSortBy="OrthodonticReferralNumber" headerText="Remiss-ID" />
                    <SortableTableHeader propertyToSortBy="Patient.PersonalSecurityId" headerText="Personnummer" />
                    <th>Remittent</th>
                    <th>Urvalstandläkare</th>
                    <th>Beslut</th>
                    <SortableTableHeader propertyToSortBy="OrthodonticReferralStatus.Description" headerText="Status" />
                    <SortableTableHeader propertyToSortBy="hasBeenComplemented" headerText="Kompletterad" />
                </tr>
            </thead>
            <tbody>
                {
                    orthodonticReferrals.length > 0 ?
                        orthodonticReferrals.map((orthodonticReferral, key) =>
                            <tr key={key} className="clickable-row">
                                <td className="table-data-link">{renderTableLink(orthodonticReferral, dateTimeToDateString(orthodonticReferral.sentDate))}</td>
                                <td className="table-data-link">{renderTableLink(orthodonticReferral, orthodonticReferral.orthodonticReferralNumber?.toString())}</td>
                                <td className="table-data-link">{renderTableLink(orthodonticReferral, formatPersonalSecurityNumberAndOrganisationNumber(orthodonticReferral.patientPersonalSecurityId))} </td>
                                <td className="table-data-link">{renderTableLink(orthodonticReferral, orthodonticReferral.referrerCareProvider?.name)}</td>
                                <td className="table-data-link">{renderTableLink(orthodonticReferral, orthodonticReferral.consultantCareProvider?.name)}</td>
                                <td className="table-data-link">{renderTableLink(orthodonticReferral, orthodonticReferral.orthodonticReferralDecision ?? "Beslut ej fattat")}</td>
                                <td className="table-data-link">{renderTableLink(orthodonticReferral, orthodonticReferral.orthodonticReferralStatus)}</td>
                                <td className="table-data-link">{renderTableLink(orthodonticReferral, orthodonticReferral.hasBeenComplemented ? "Ja" : "Nej")}</td>
                            </tr>
                        )
                        : <tr><td colSpan={8}>Hittade inga ortodontiremisser!</td></tr>
                }
            </tbody>
        </Table>
    )
}